import { MoneySchema } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";

const FulfillmentLineItemSchema_ = z
  .object({
    externalId: z.string().meta({ privacy: privacy.id.external.resource }),
    imageUrl: z.string().nullish().meta({ privacy: privacy.publicUrl }),
    customAttributes: z
      .array(
        z
          .object({
            key: z.string().meta({ privacy: privacy.productCatalogText }),
            value: z.string().meta({ privacy: privacy.text.customer }),
          })
          .meta({ privacy: privacy.structured }),
      )
      .meta({ privacy: privacy.structured }),
    quantity: z.number().meta({ privacy: privacy.quantity }),
    currentQuantity: z.number().meta({ privacy: privacy.quantity }),
    productId: z
      .string()
      .nullish()
      .meta({ privacy: privacy.id.external.resource }),
    variantId: z
      .string()
      .nullish()
      .meta({ privacy: privacy.id.external.resource }),
    lineItemId: z.string().meta({ privacy: privacy.id.external.resource }),
    title: z.string().meta({ privacy: privacy.productCatalogText }),
    variantTitle: z.string().meta({ privacy: privacy.productCatalogText }),
    productTitle: z
      .string()
      .nullish()
      .meta({ privacy: privacy.productCatalogText }),
    sku: z.string().nullish().meta({ privacy: privacy.productSku }),
    bin: z.string().nullish().meta({ privacy: privacy.resourceLabel }),
    barcode: z.string().nullish().meta({ privacy: privacy.productSku }),
    originalUnitPrice: MoneySchema.meta({ privacy: privacy.structured }),
    discountedUnitPrice: MoneySchema.meta({ privacy: privacy.structured }),
    totalPrice: MoneySchema.meta({ privacy: privacy.structured }),
    selectedOptions: z
      .array(
        z
          .object({
            name: z.string().meta({ privacy: privacy.productCatalogText }),
            value: z.string().meta({ privacy: privacy.productCatalogText }),
          })
          .meta({ privacy: privacy.structured }),
      )
      .nullish()
      .meta({ privacy: privacy.structured }),
    totalDiscountedPrice: MoneySchema.meta({ privacy: privacy.structured }),
    totalTax: MoneySchema.meta({ privacy: privacy.structured }),
  })
  .meta({ privacy: privacy.structured });
export const FulfillmentLineItemSchema: z.ZodType<FulfillmentLineItem> =
  FulfillmentLineItemSchema_;

export interface FulfillmentLineItem extends z.infer<
  typeof FulfillmentLineItemSchema_
> {}
export interface IFulfillmentLineItem extends z.ZodType<FulfillmentLineItem> {}
